import type { ReactNode } from 'react';
import SubPageContent from '@/components/layout/SubPageContent';

type SubPageSectionProps = {
  id?: string;
  children: ReactNode;
  className?: string;
  /** 会社ページ ABOUT/SERVICE 用のやや広い余白 */
  spacing?: 'default' | 'wide' | 'compact';
};

/** 下層ページ共通: コンクリート上のセクション枠 */
export default function SubPageSection({
  id,
  children,
  className = '',
  spacing = 'default',
}: SubPageSectionProps) {
  const py =
    spacing === 'wide'
      ? 'py-28 md:py-40'
      : spacing === 'compact'
        ? 'py-20 md:py-28'
        : 'py-24 md:py-32';

  return (
    <section id={id} className={`relative w-full ${py} ${className}`}>
      <SubPageContent>{children}</SubPageContent>
    </section>
  );
}
